import { render, staticRenderFns } from "./ScatterDistPVP.vue?vue&type=template&id=f1367d6c"
import script from "./ScatterDistPVP.vue?vue&type=script&lang=js"
export * from "./ScatterDistPVP.vue?vue&type=script&lang=js"
import style0 from "./ScatterDistPVP.vue?vue&type=style&index=0&id=f1367d6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports